import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/home/Home';
import Privacidad from './pages/privacidad/Privacidad';
import Gracias from './pages/gracias/Gracias';
import GraciasCitas from './pages/gracias-citas/GraciasCitas';
import Calendario from './pages/calendario/Calendario';
import Cronograma from './pages/cronograma/Cronograma';


function App() {
  useEffect(() => {
    let previousScroll = window.scrollY || 0;

    const handleScroll = () => {
      const currentScroll = window.scrollY || 0;

      if (currentScroll > previousScroll) {
        document.body.classList.add('scrolled');
      } else if (currentScroll <= 0) {
        // Only remove when the user scrolls back to the top
        document.body.classList.remove('scrolled');
      }

      previousScroll = currentScroll;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.body.classList.remove('scrolled');
    };
  }, []);

  return (
    <Router>
      <div>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacidad" element={<Privacidad />} />
          <Route path="/gracias" element={<Gracias />} />
          <Route path="/gracias-citas" element={<GraciasCitas />} />
          <Route path="/calendario" element={<Calendario />} />
          <Route path="/calendario/:sede" element={<Calendario />} />
          <Route path="/cronograma" element={<Cronograma />} />
          <Route path="/cronograma/:sede" element={<Cronograma />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
